import has from 'lodash/has';
import { call, put, select, all } from 'redux-saga/effects';
import * as types from '../../constants/ActionTypes';
import Api from '../../functions/Api';
import { triggerUpdateQuestData } from '../quests';

export function* postListedData(action) {
  try {
    const { data } = yield call(
      Api.post,
      `v2/products/${action.idProduct}/${action.endpoint}/`,
      {
        data: {
          ...action.data,
        },
        isDecamelize: false,
      }
    );

    if (data && data.id && has(data, 'text')) {
      yield put({
        type: types.POST_LISTED_DATA_SUCCESS,
        data,
        attribute: action.endpoint,
      });
    }

    if (data && data.id && has(data, 'price')) {
      yield put({
        type: types.POST_LISTED_PRICE_DATA_SUCCESS,
        data,
        attribute: 'price',
      });
    }
  } catch (error) {
    yield put({
      type: types.POST_LISTED_DATA_FAILURE,
      errors: [error],
    });
    yield put({ type: types.NETWORK_ERROR, error });
  }
}

export function* sendListedData(action) {
  try {
    const { data } = yield call(
      Api.put,
      `v2/products/${action.idProduct}/${action.endpoint}/${action.idElement}/`,
      {
        data: {
          ...action.data,
        },
      }
    );
    const questId = yield select((state) => state.quests.currentQuestId);
    const quests = yield select((state) => state.quests.quests);
    const { generatedByAi } = quests[0] || {};

    if (data && data.id && has(data, 'text')) {
      yield put({
        type: types.SEND_LISTED_DATA_SUCCESS,
        data,
        attribute: action.endpoint,
      });
      if (generatedByAi === true) {
        yield put(triggerUpdateQuestData(questId));
      }
    }

    if (data && has(data, 'cover')) {
      yield put({
        type: types.SEND_LISTED_IMAGES_DATA_SUCCESS,
        data,
        attribute: 'images',
      });
      yield put(triggerUpdateQuestData(questId));
      yield put({
        type: types.FETCH_QUEST,
        id: questId,
        isForSync: true,
      });
    }

    if (data && has(data, 'price')) {
      yield put({
        type: types.SEND_LISTED_PRICE_DATA_SUCCESS,
        data,
        attribute: 'price',
      });
    }
  } catch (error) {
    yield put({
      type: types.SEND_LISTED_DATA_FAILURE,
      errors: [error],
    });
    yield put({ type: types.NETWORK_ERROR, error });
  }
}

export function* deleteListedData(action) {
  try {
    const response = yield call(
      Api.delete,
      `v2/products/${action.idProduct}/${action.endpoint}/${action.idElement}/`
    );

    if (response && action.endpoint === 'prices') {
      yield put({
        type: types.DELETE_LISTED_DATA_SUCCESS,
        id: action.idElement,
        attribute: 'priceLevels',
      });
    }

    if (
      response &&
      action.endpoint !== 'images' &&
      action.endpoint !== 'prices'
    ) {
      yield put({
        type: types.DELETE_LISTED_DATA_SUCCESS,
        id: action.idElement,
        attribute: action.endpoint,
      });
    }

    if (response && action.endpoint === 'images') {
      const isCover = yield select(
        (state) =>
          state.publishing.receivedPublishData.images.find(
            (x) => x.id === action.idElement
          ).cover
      );
      yield put({
        type: types.DELETE_IMAGE_SUCCESS,
        id: action.idElement,
        attribute: action.endpoint,
      });

      if (isCover) {
        yield put({
          type: types.REQUEST_PRODUCT,
          id: action.idProduct,
        });
        const questId = yield select((state) => state.quests.currentQuestId);

        yield put({
          type: types.FETCH_QUEST,
          id: questId,
          isForSync: true,
        });
      }
    }
  } catch (error) {
    yield put({
      type: types.DELETE_LISTED_DATA_FAILURE,
      errors: [error],
    });
    yield put({ type: types.NETWORK_ERROR, error });
  }
}

export function* convertAudioGuides({ idProduct, nextCurrencyId }) {
  try {
    const currencies = yield select((state) => state.currencies.items);
    const priceLevels = yield select((state) => state.publishing.priceLevels);
    const defaultCurrency = yield select(
      (state) => state.publishing.receivedPublishData.defaultCurrency
    );

    const nextCurrencyRate = currencies.find(
      (currency) => currency.id === nextCurrencyId
    ).rate;

    yield all(
      priceLevels.map((priceLevel) =>
        call(sendListedData, {
          type: types.SEND_LISTED_DATA,
          data: {
            price: priceLevel.price * (nextCurrencyRate / defaultCurrency.rate),
          },
          idProduct,
          idElement: priceLevel.id,
          endpoint: 'prices',
        })
      )
    );
  } catch (error) {
    yield put({
      type: types.CONVERT_AUDIO_GUIDES_PRICES_FAILURE,
      errors: [error],
    });
    yield put({ type: types.NETWORK_ERROR, error });
  }
}
